import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../rootState'

export const getIsMobile = createSelector(
  (state: RootState) => state.app,
  app => app.isMobile,
)
